import React from 'react';
import CatalogCard from '../catalog/CatalogCard';
import CommerceButton from '../ui/CommerceButton';
import Price from '../ui/Price';
import Countdown from './Countdown';
import { useTranslation } from '../../hooks/useTranslation';
import { productImageUrl } from '../../utils/productImageUrl';

export default function AuctionCard({ auction, priority = false }) {
  const { t } = useTranslation('auctions');
  const href = `/licitatii/${auction.slug}`;
  const hasBids = auction.topBid != null;
  const active = auction.phase === 'live' || auction.phase === 'scheduled';
  const bidLabel = hasBids ? `${auction.bidCount} ${t(auction.bidCount === 1 ? 'detail.bidCountOne' : 'detail.bidCount')}` : t('detail.startPrice');
  const timingLabel = t(auction.phase === 'live' ? 'countdown.endsIn' : 'countdown.startsIn');
  return <CatalogCard {...{ href, priority }} title={auction.title} image={auction.image || productImageUrl()}
    badge={<span className={`inline-flex max-w-full flex-wrap items-center gap-x-1.5 rounded-md px-2 py-1 text-[9px] font-extrabold leading-3 ${active ? 'bg-purple-100 text-purple-900' : 'bg-krit-paper text-krit-muted'}`}>
      <span>{t('detail.kicker')}</span><span aria-hidden="true">·</span><span>{t(`phase.${auction.phase}`)}</span>
    </span>}
    price={<>
      <span className="sr-only">{t(hasBids ? 'detail.topBid' : 'detail.startPrice')}: </span>
      <Price amount={hasBids ? auction.topBid : auction.startPrice} className="text-lg font-extrabold min-[769px]:text-xl [&_sup]:text-[10px]" />
      <span className="text-[10px] font-semibold text-krit-muted">{bidLabel}</span>
    </>}
    action={<div className="inline-flex w-full justify-center">
      <CommerceButton href={href} availability="auction" text={auction.phase === 'live' ? undefined : t('list.viewAuction')} compact
        subtext={active ? <span title={timingLabel}><span className="sr-only">{timingLabel} </span><Countdown target={auction.phase === 'live' ? auction.endsAt : auction.startsAt} className="!font-semibold !tracking-normal" /></span> : t(`phase.${auction.phase}`)} />
    </div>} />;
}
